export default class EnumCandidate {
  static auditStatusListData = {
    0: "未阅卷",
    1: "通过",
    2: "待定",
    3: "拒绝"
  };
}
